import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { FormatCurrenciesProps, FormatCurrencies } from './FormatCurrencies';
import { FormatCurrency } from './FormatCurrency/FormatCurrency';
import { FormatCurrencyType } from './FormatCurrency/format-currency-type.enum';
import { RANGE_SIGN } from 'app/constants';

type FormatCurrenciesRangeProps = {
  min: number;
  max: number;
} & Omit<FormatCurrenciesProps, 'amount'>;

export const FormatCurrenciesRange: FC<FormatCurrenciesRangeProps> = (props) => {
  const { min, max, ...rest } = props;

  if (min === max) {
    return <FormatCurrencies amount={min} {...rest} />;
  }

  return (
    <Box sx={{ whiteSpace: 'normal' }}>
      <FormatCurrency amount={min} {...rest} type={FormatCurrencyType.None} />
      <Typography component="span">{` ${RANGE_SIGN} `}</Typography>
      <FormatCurrency amount={max} {...rest} type={FormatCurrencyType.Crypto} />
    </Box>
  );
};
